<div class="container-fluid">
  <app-pagetitle title="BOARD" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="main-card-container">
    <div class="card">
      <div class="card-body">
        <!-- Header Section -->
        <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
          <h4 class="card-title mb-0">Boards</h4>
          
          <div class="d-flex align-items-center">
            <div class="dropdown me-2" ngbDropdown *ngIf="!readonly">
              <a href="javascript: void(0);" class="btn btn-light dropdown-toggle" ngbDropdownToggle>
                <i class="mdi mdi-dots-vertical"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                <a routerLink="../boardUpload" class="dropdown-item">Import Boards</a>
                <a href="javascript:void(0);" class="dropdown-item" (click)="downloadCsv()">Export Boards</a>
              </div>
            </div>
            <button class="btn btn-light" (click)="refresh()" ngbTooltip="Refresh">
              <i class="mdi mdi-refresh"></i>
            </button>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="row g-2 mb-4">
          <div class="col-12 col-sm-auto" *ngIf="!readonly">
            <button class="btn btn-primary w-100" (click)="onAddNew(addEditModal)">
              <i class="mdi mdi-plus-circle me-1"></i>Add Board
            </button>
          </div>
          <div class="col-12 col-sm-auto" *ngIf="!readonly">
            <button
              class="btn btn-outline-primary w-100"
              type="button"
              [disabled]="isImportingBoards"
              (click)="bulkImportInput.click()">
              <i class="mdi mdi-file-excel me-1"></i>{{ isImportingBoards ? 'Importing...' : 'Import Boards (Excel)' }}
            </button>
            <input
              #bulkImportInput
              type="file"
              accept=".xlsx,.xls"
              class="d-none"
              (change)="onBulkImportExcelChange($event)">
          </div>
          <div class="col-12 col-sm-auto" *ngIf="!readonly">
            <button
              class="btn btn-outline-secondary w-100"
              type="button"
              (click)="downloadBoardImportTemplate()">
              <i class="mdi mdi-download me-1"></i>Download Import Template
            </button>
          </div>
          <div class="col-12 col-sm-auto" *ngIf="!readonly">
            <button class="btn btn-secondary w-100" (click)="manageBoardTypes()">
              <i class="mdi mdi-tune me-1"></i>Manage Board Types
            </button>
          </div>
          <div class="col-12 col-sm-auto" *ngIf="!readonly">
            <button class="btn btn-secondary w-100" (click)="manageGames()">
              <i class="mdi mdi-gamepad-variant me-1"></i>Manage Games
            </button>
          </div>
        </div>

        <!-- Search Box -->
        <div class="search-box mb-4">
          <div class="position-relative">
            <input type="text" 
                   class="form-control" 
                   placeholder="Search boards..."
                   [(ngModel)]="term" 
                   (ngModelChange)="onSearchChange($event)">
            <i class="mdi mdi-magnify search-icon"></i>
          </div>
        </div>

        <!-- Table Section -->
        <div class="table-responsive">
          <table class="table table-centered table-hover">
            <thead class="table-light">
              <tr>
                <th>Asset Tag</th>
                <th>Serial Number</th>
                <th>Board Type</th>
                <th>Game Name</th>
                <th>Renewal</th>
                <th>Location</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filteredBoards">
                <td>
                  <a href="javascript:void(0);" (click)="openBoardStatsModal(item.assetTag)">
                    {{ item.assetTag }}
                  </a>
                </td>
                <td>{{item.serialNumber}}</td>
                <td>
                  <span class="badge bg-light text-dark" *ngIf="item.boardType">
                    {{item.boardType?.name}}
                  </span>
                </td>
                <td>
                  <div class="d-flex flex-column">
                    <span>{{item.installedGamePackage?.name}}</span>
                    <small class="text-muted">{{item.installedGamePackage?.version}}</small>
                  </div>
                </td>
                <td>
                  <div class="d-flex flex-column">
                    <span>{{item.renewalMetric}}</span>
                    <small class="text-muted">Quota: {{item.renewalQuota}}</small>
                  </div>
                </td>
                <td>
                  <div class="d-flex flex-column">
                    <span>{{item.location?.locationTag}}</span>
                    <small class="text-muted">{{item.location?.locationName}}</small>
                  </div>
                </td>
                <td>
                  <div class="form-check form-switch d-flex flex-column gap-2">
                    <!-- Enabled Status -->
                    <div class="switch-item">
                      <input type="checkbox" 
                             class="form-check-input" 
                             [checked]="item.enabled"
                             (change)="onCheckBoxChanged($event, item)"
                             [disabled]="readonly"
                             id="enabled-{{item.id}}">
                      <label class="form-check-label ms-2" for="enabled-{{item.id}}">
                        Enabled
                      </label>
                    </div>
                
                    <!-- Dynamic RTP Status -->
                    <div class="switch-item">
                      <input type="checkbox" 
                             class="form-check-input" 
                             [checked]="item.fusionConnect"
                             (change)="toggleFusionConnect($event, item)"
                             [disabled]="readonly"
                             id="fusionConnect-{{item.id}}">
                      <label class="form-check-label ms-2" for="fusionConnect-{{item.id}}">
                       Fortune Konnect
                      </label>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex gap-2">
                    <button *ngIf="!readonly" 
                            class="btn btn-sm btn-light" 
                            (click)="onEdit(addEditModal, item)" 
                            ngbTooltip="Edit">
                      <i class="mdi mdi-pencil"></i>
                    </button>
                    <button *ngIf="!readonly" 
                            class="btn btn-sm btn-light text-danger" 
                            (click)="onDelete(item.id)" 
                            ngbTooltip="Delete">
                      <i class="mdi mdi-trash-can"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Empty State -->
          <div *ngIf="filteredBoards?.length === 0" class="text-center py-5">
            <p class="text-muted mb-0">No boards found</p>
          </div>
        </div>
        <div class="d-flex justify-content-center my-3" *ngIf="hasMore">
          <button class="btn btn-outline-primary" (click)="loadNextPage()" [disabled]="isLoadingPage">
            {{ isLoadingPage ? 'Loading...' : 'Load more boards' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Keep the modal template as is -->
  <!-- Add/Edit Modal Template -->
  <ng-template #addEditModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{addEditMode}} Board</h4>
      <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>
    
    <div class="modal-body">
      <form [formGroup]="addEditFormGroup">
        <div class="form-group" formGroupName="boardGroup">
          <!-- Asset Tag -->
          <div class="mb-3">
            <label class="form-label">Asset Tag</label>
            <input type="text" 
                   class="form-control" 
                   formControlName="assetTag" 
                   placeholder="Enter asset tag">
          </div>

          <!-- Serial Number -->
          <div class="mb-3">
            <label class="form-label">Serial Number</label>
            <input type="text" 
                   class="form-control" 
                   formControlName="serialNumber" 
                   placeholder="Enter serial number">
          </div>

          <!-- Board Type -->
          <div class="mb-3">
            <label class="form-label">Board Type</label>
            <select class="form-select" formControlName="boardType">
              <option value="">Select board type</option>
              <option *ngFor="let type of boardTypes" [value]="type.id">
                {{type.name}}
              </option>
            </select>
          </div>

          <!-- Game -->
     <div class="mb-3">
  <label class="form-label">Game</label>
  <ng-select [items]="games"
             bindLabel="displayName"
             bindValue="combined"
             placeholder="Select game"
             [searchable]="true"
             formControlName="installedGamePackage">
  </ng-select>
</div>


          <!-- Location -->
<div class="mb-3">
  <label class="form-label">Location</label>
  <ng-select [items]="locations"
             bindLabel="displayName"
             bindValue="locationTag"
             placeholder="Select location"
             [searchable]="true"
             formControlName="locationTag">
  </ng-select>
</div>


          <!-- Cabinet -->
          <!-- <div class="mb-3">
            <label class="form-label">Cabinet</label>
            <select class="form-select" formControlName="cabinetTag">
              <option value="">Select cabinet</option>
              <option *ngFor="let cabinet of filteredCabinets" [value]="cabinet.cabinetTag">
                {{cabinet.cabinetTag}} - {{cabinet.cabinetType?.name}}
              </option>
            </select>
          </div> -->

          <!-- Renewal Metric -->
          <div class="mb-3">
            <label class="form-label">Renewal Metric</label>
            <select class="form-select" formControlName="renewalMetric">
              <option *ngFor="let metric of renewalMetricTypes" [value]="metric.key">
                {{metric.value}}
              </option>
            </select>
          </div>

          <!-- Renewal Quota -->
          <div class="mb-3">
            <label class="form-label">Renewal Quota</label>
            <input type="number" 
                   class="form-control" 
                   formControlName="renewalQuota" 
                   placeholder="Enter quota">
          </div>

          <!-- Install Date -->
          <div class="mb-3">
            <label class="form-label">Install Date</label>
            <input type="Date" 
                   class="form-control" 
                   formControlName="installDate">
          </div>

          <!-- Removal Date -->
          <div class="mb-3">
            <label class="form-label">Removal Date</label>
            <input type="date" 
                   class="form-control" 
                   formControlName="removalDate">
          </div>

          <!-- Enabled Status -->
          <div class="mb-3">
            <div class="form-check">
              <input type="checkbox" 
                     class="form-check-input" 
                     formControlName="enabled" 
                     id="enabled">
              <label class="form-check-label" for="enabled">
                Enabled
              </label>
            </div>
          </div>

          <!-- Notes -->
          <div class="mb-3">
            <label class="form-label">Notes</label>
            <textarea class="form-control" 
                      formControlName="notes" 
                      rows="3" 
                      placeholder="Enter notes"></textarea>
          </div>
        </div>
      </form>
    </div>
    
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="modal.close('Save click')">Save Changes</button>
    </div>
  </ng-template>
</div>
